module.exports = __webpack_public_path__ + "static/media/next-big-03.f46fe938.svg";